<ion-input type="text" class="full outline" [disabled]="IsDisabled" [value]="SummaryText"
	(click)="OnPresentPopover($event)" readonly [placeholder]="Placeholder" />

<span class="iss-helper" *ngIf="HelperText">{{ HelperText }}</span>

<div class="iss-chips" *ngIf="Selected.length">
	<span class="iss-chip" *ngFor="let item of Selected; trackBy: trackByFn"
		[title]="'[' + (item?.Code || '--') + '] ' + (item?.Description || '')">
		<span class="iss-chip-code">{{ item?.Code }}</span>
		<span class="iss-chip-desc">{{ item?.Description || '--' }}</span>
		<ion-icon *ngIf="!IsDisabled" name="close" class="iss-chip-remove"
			(click)="$event.stopPropagation(); Remove(item)" aria-label="Remover"></ion-icon>
	</span>
</div>

<ion-popover #popover [isOpen]="IsOpen" (didDismiss)="IsOpen = false" class="select-search iss-popover">
	<ng-template>
		<ion-header class="iss-header">
			<ion-toolbar>
				<ion-searchbar #search placeholder="pesquisar"></ion-searchbar>
			</ion-toolbar>
		</ion-header>

		<ion-content [scrollY]="false" class="ion-no-padding">
			<ng-container *ngIf="(Data | FilterByFields: (search?.value||'')) as filtered">
				<cdk-virtual-scroll-viewport class="ion-content-scroll-host iss-viewport" itemSize="40" minBufferPx="600"
					maxBufferPx="1200" [style.height.px]="ViewportHeight(filtered.length)">

					<ion-item *cdkVirtualFor="let item of filtered; trackBy: trackByFn" button detail="false"
						lines="none" class="iss-option" [class.selected]="item?.Checked" (click)="Toggle(item)">
						<ion-checkbox slot="start" class="iss-check" [checked]="item?.Checked"></ion-checkbox>
						<ion-label class="iss-label" [title]="'[' + (item?.Code || '--') + '] ' + (item?.Description || '--')">[{{
							item?.Code || '--' }}] {{ item?.Description || '--' }}</ion-label>
					</ion-item>

					<div class="iss-empty" *ngIf="filtered.length == 0">sem resultados</div>
				</cdk-virtual-scroll-viewport>
			</ng-container>
		</ion-content>
	</ng-template>
</ion-popover>
